// Core Styles
//import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import "react-toastify/dist/ReactToastify.css";

//// Core Scripts
import "jquery";
import "bootstrap";

// Theme Scripts
import "../lib/looper/javascript/theme";

// Custom Styles
import "../styles/app.scss";

// Polyfills
import "core-js/stable";

// Initialization
const browserDate = document.getElementById("login-form-slim-browser-date") as HTMLInputElement;
if (browserDate) {
  // Used to set the user's time zone when they login.
  browserDate.value = (new Date()).toString();
}
